import React from "react";
import {
  formatPriceMonthlyNoCurrency,
  getPriceMinUnitAmount
} from "components/FormerEditor/common/currency";
import { INTERVAL_SHORTHAND_MAP } from "components/FormerEditor/common/constants";
import { RECURRING_INTERVALS } from "utils/constants/payment";

const MonthlyIntervalShorthand = ({ price }) => {
  let content = null;
  if (
    price.recurring &&
    price.recurring.interval === RECURRING_INTERVALS.YEAR
  ) {
    const formattedMonthlyAmount = formatPriceMonthlyNoCurrency({
      amount: getPriceMinUnitAmount(price),
      interval: price.recurring && price.recurring.interval,
      currency: price.currency
    });

    content = (
      <div className="f7 pr1">{`${formattedMonthlyAmount} / ${
        INTERVAL_SHORTHAND_MAP[RECURRING_INTERVALS.MONTH]
      }`}</div>
    );
  }
  return content;
};

export default MonthlyIntervalShorthand;
